import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function NavBar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const link = (to, label, testId) => (
    <Link
      to={to}
      data-testid={testId}
      className={`label-overline hover:text-ink-black transition-colors ${
        location.pathname === to ? "text-ink-black" : ""
      }`}
    >
      {label}
    </Link>
  );

  return (
    <header className="border-b border-rule bg-parchment-base/80 backdrop-blur-sm sticky top-0 z-30">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-5 flex items-center justify-between gap-6">
        <Link to="/" data-testid="nav-home-link" className="flex items-baseline gap-2">
          <span className="font-display text-2xl sm:text-3xl tracking-tight">Hearth <span className="italic text-wax-red">&amp;</span> Hermit</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {link("/browse/hermitages", "Hermitages", "nav-hermitages")}
          {link("/browse/hermits", "Hermits", "nav-hermits")}
          {link("/manifesto", "Manifesto", "nav-manifesto")}
          {link("/founding", "Founding", "nav-founding")}
          {link("/pricing", "Pricing", "nav-pricing")}
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard-btn" className="ghost-button hidden sm:inline-block">Dashboard</Link>
              <button onClick={handleLogout} data-testid="nav-logout-btn" className="label-overline text-ink-marginalia hover:text-wax-red transition-colors">Sign out</button>
            </>
          ) : (
            <>
              <Link to="/sign-in" data-testid="nav-signin-btn" className="label-overline hover:text-ink-black transition-colors">Sign in</Link>
              <Link to="/sign-up" data-testid="nav-signup-btn" className="wax-button">Begin</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
